import { FormProvider, useForm } from 'react-hook-form';
import RadioInputLists from '@components/Input/RadioInputLists';
import InputText from '@components/Input/Text';
import InputDate from '@components/Input/Date';
import InputFileUploader from '@components/Input/File';
import { styled } from '@mui/material/styles';
import { FormGroup, FormLabel, Box } from '@mui/material';

export const defaultFilters = {
    dateOfBirth: null,
};

const listGenre = [
    {
        label: 'Femme',
        value: 'femme',
    },
    {
        label: 'Homme',
        value: 'homme',
    },
    {
        label: 'Non genré',
        value: 'non',
    },
];

const StyledFormGroup = styled(FormGroup)(({ theme }) => ({
    marginBottom: '16px',
}));

const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
    '&.MuiFormLabel-root': {
        color: theme.palette.secondary.main,
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 500,
        marginBottom: 8,
    },
    '& .required': {
        color: theme.palette.error.main,
    },
}));

const SettingsProfilePage = () => {
    const methods = useForm({
        defaultValues: defaultFilters,
    });

    return (
        <FormProvider {...methods}>
            {/* Input Gender Example */}
            <StyledFormGroup>
                <StyledFormLabel
                    sx={{
                        '&.MuiFormLabel-root': {
                            marginBottom: '16px',
                        },
                    }}>
                    Genre
                    <Box component="span" className="required">
                        *
                    </Box>
                </StyledFormLabel>
                <RadioInputLists name="Genre" options={listGenre} />
            </StyledFormGroup>

            {/* Input Postal Code Example */}
            <StyledFormGroup>
                <StyledFormLabel>
                    Code postal
                    <Box component="span" className="required">
                        *
                    </Box>
                </StyledFormLabel>
                <InputText name="postalCode" placeholder="75015" />
            </StyledFormGroup>

            {/* Input Date Example */}
            <StyledFormGroup>
                <StyledFormLabel>
                    Date
                    <Box component="span" className="required">
                        *
                    </Box>
                </StyledFormLabel>
                <InputDate name="dateOfBirth" />
            </StyledFormGroup>

            {/* Upload File Example */}
            <StyledFormGroup>
                <StyledFormLabel>
                    ID (Carte Nationale d’Identité ou Passeport)
                    <Box component="span" className="required">
                        *
                    </Box>
                </StyledFormLabel>
                <InputFileUploader
                    label="Glissez déposez votre fichier (pdf, jpg, jpeg, png) pour télécharger votre RIB ici."
                    maxSize="5MB"
                />
            </StyledFormGroup>
        </FormProvider>
    );
};

export default SettingsProfilePage;
